// Functionality applied to all pages.

$(document).ready(function () {
  // Create a namespace.
  window.SOMAR = window.SOMAR || {};

  const $footer = $('#footer');
  const navitems = $('#header').find('.nav-item--with-children');

  navitems.on('click', function () {
    $(this).toggleClass('active').siblings().removeClass('active');
  });

  if ($footer.length) {
    $footer.find('#backToTop').on('click', function () {
      $('body,html').animate({ scrollTop: 0 }, 500);
    });
  }
});
